import Layout from '../shared/Layout';
import PageHeader from '../shared/PageHeader';
import '../../css/conversations.css';
import TelegramDiagnostics from './TelegramDiagnostics';
import BotErrorsPanel from './BotErrorsPanel';

export default function ConversationsBotHealth() {
  return (
    <Layout>
      <PageHeader name="Здоров'я бота" />
      <main className="main-block">
        <div className="main-content txt-c conv-dashboard-page">
          <TelegramDiagnostics />
          <BotErrorsPanel />
        </div>
      </main>
    </Layout>
  );
}
